const Style = {
    auth: "auth"
}

export default Style;